// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 100 101"
    {...props}
  >
    <path fill="#fff" d="M0 0H100V100H0z" transform="translate(0 .125)" />
    <path
      stroke="#9FA5AB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.596}
      d="M59.6037 34.7891C58.9092 34.0984 51.2592 36.0885 47.4491 29.3524C47.4491 29.3524 45.0813 33.4286 40.5469 34.301"
    />
    <path
      stroke="#9FA5AB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.596}
      d="M39.0903 39.411C39.5394 40.8675 40.4884 41.8931 41.2906 41.8399C42.6355 46.3626 46.0068 49.5703 49.9519 49.5703C53.9255 49.5703 57.3175 46.3172 58.6416 41.7438C58.6871 41.7684 58.7325 41.7879 58.7819 41.8022C59.6192 42.0618 60.694 40.9909 61.1808 39.411C61.6689 37.8312 61.3833 36.3422 60.546 36.0826C60.1254 35.9541 59.6464 36.1579 59.2116 36.5928C59.209 36.5382 59.2051 36.4863 59.2012 36.4331C59.5023 35.4906 59.6633 34.4872 59.6633 33.446C59.6633 28.0146 55.2613 23.6126 49.8298 23.6126C44.3984 23.6126 39.9964 28.0146 39.9964 33.446C39.9964 34.3716 40.1249 35.2686 40.3625 36.1176C40.1444 36.0359 39.9276 36.0203 39.7251 36.0826C38.8865 36.3422 38.6022 37.8312 39.0903 39.411Z"
    />
    <path
      stroke="#9FA5AB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.596}
      d="M45.3996 48.0083C45.3996 48.0083 46.6913 53.8967 36.8929 53.8967 27.0958 53.8967 26.4688 76.9453 26.4688 76.9453M54.5328 48.0083C54.5328 48.0083 53.2411 53.8967 63.0396 53.8967 72.8367 53.8967 73.4649 76.9453 73.4649 76.9453M59.4437 53.7018 49.8984 76.8672M40.1406 53.7018 49.6872 76.8672M48.0117 55.0213 45.8438 67.2109M51.8828 55.0195 54.6089 49.7218"
    />
    <path
      stroke="#9FA5AB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M47.8125 42.1406V42.1406C48.8876 43.6158 51.088 43.6158 52.1631 42.1406V42.1406"
    />
    <path
      stroke="#9FA5AB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.596}
      d="M45.3281 49.7201L48.0049 55.0179H51.8747L53.9933 66.9219"
    />
  </svg>
);
const IconPortraitOutline = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconPortraitOutline;
